import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d545a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sole-trader-data-wrapper !tw-mt-4 rmd:!tw-mt-8" }
const _hoisted_2 = { class: "input-field" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "VAT Number (Optional)", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_WizardModal = _resolveComponent("WizardModal")!

  return (_openBlock(), _createBlock(_component_WizardModal, {
    hideFooter: true,
    hideBackButton: true,
    singleData: $setup.modelDetails,
    onOnClose: $setup.onClickBackButton
  }, {
    content: _withCtx(() => [
      _createVNode(_component_v_form, {
        rules: $setup.validation,
        ref: "vatTaxFormRef",
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_v_text_field, {
                density: "compact",
                placeholder: "eg. GB123456789",
                rules: $setup.validation.vatNumber,
                modelValue: $setup.formData.vatNumber,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formData.vatNumber) = $event)),
                variant: "outlined",
                class: "c-input rounded-full"
              }, null, 8, ["rules", "modelValue"])
            ]),
            _createVNode(_component_v_btn, {
              class: "button button-orange !tw-mt-6 rmd:!tw-mt-8",
              onClick: $setup.onClickTaxVatSave,
              loading: $setup.isLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save")
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ])
        ]),
        _: 1
      }, 8, ["rules"])
    ]),
    _: 1
  }, 8, ["singleData", "onOnClose"]))
}